import {
  ArrowForwardIos,
  ContentCopy,
  Delete,
  NoteAlt
} from "@mui/icons-material";
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const textContent = data?.text || data?.label || "Clique duas vezes para configurar a anotação interna";

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        padding: "8px",
        borderRadius: "8px",
        boxShadow: "rgba(0, 0, 0, 0.08) 0px 3px 6px",
        border: "1px solid #f59e0b",
        minWidth: "190px",
        maxWidth: "220px",
        position: "relative"
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#d97706",
          width: "18px",
          height: "18px",
          top: "20px",
          left: "-12px",
          cursor: "pointer"
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: "none"
          }}
        />
      </Handle>

      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 5,
          top: 5,
          cursor: "pointer",
          gap: 6
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "13px", height: "13px", color: "#d97706" }}
        />

        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "13px", height: "13px", color: "#d97706" }}
        />
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          marginBottom: "6px"
        }}
      >
        <NoteAlt
          sx={{
            width: "18px",
            height: "18px",
            color: "#d97706"
          }}
        />
        <span style={{ color: "#1e293b", fontSize: "14px", fontWeight: "bold" }}>
          Anotação
        </span>
        <span
          style={{
            fontSize: "9px",
            backgroundColor: "#fef3c7",
            color: "#92400e",
            padding: "1px 4px",
            borderRadius: "4px",
            fontWeight: "600",
            marginLeft: "auto",
            marginRight: "40px"
          }}
        >
          Interna
        </span>
      </div>

      <div
        style={{
          backgroundColor: "#fffbeb",
          border: "1px dashed #fde68a",
          borderRadius: "6px",
          padding: "6px 8px",
          color: "#451a03",
          fontSize: "11px",
          lineHeight: "1.4",
          maxHeight: "80px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordBreak: "break-word",
          whiteSpace: "pre-wrap"
        }}
      >
        {textContent}
      </div>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#d97706",
          width: "18px",
          height: "18px",
          top: "70%",
          right: "-11px",
          cursor: "pointer"
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: "none"
          }}
        />
      </Handle>
    </div>
  );
});

